import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { usePreferences } from '../../contexts/PreferencesContext'; // <-- importieren
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import TopicCard from '../../components/TopicCard/TopicCard';
import OptionsModal from '../../components/OptionsModal/OptionsModal';
import styles from './Dashboard.module.css';

// Zentrale Definition aller verfügbaren Widgets (unverändert)
const ALL_WIDGETS = {
  'film-favs': { title: 'film-favs', description: 'Lieblingsfilme verwalten' },
  'music-favs': { title: 'music-favs', description: 'Musik teilen' },
  'family-calendar': { title: 'family-calendar', description: 'Gemeinsame Termine' },
  'family-chat': { title: 'family-chat', description: 'Chat mit der Familie' },
  'schwurbler-newsfeed': { title: 'schwurbler-newsfeed', description: 'Newsfeed' }
};

const Dashboard = () => {
  const { user } = useAuth();
  const { preferences } = usePreferences(); // <-- Hole preferences aus Context
  const [showOptions, setShowOptions] = useState(false);

  // Widget-Konfiguration aus preferences (mit Fallback auf Defaults)
  const widgetOrder = preferences.widgets?.order ?? Object.keys(ALL_WIDGETS);
  const widgetVisibility = preferences.widgets?.visibility ?? {};
  const visibleWidgets = widgetOrder.filter(id => widgetVisibility[id] !== false);

  return (
    <div className={styles.container}>
      <DashboardHeader user={user} onOptionsClick={() => setShowOptions(true)} />
      <div className={styles.content}>
        <div className={styles.grid}>
          {visibleWidgets.map(widgetId => (
            <TopicCard
              key={widgetId}
              title={ALL_WIDGETS[widgetId].title}
              description={ALL_WIDGETS[widgetId].description}
            />
          ))}
        </div>
      </div>
      {showOptions && <OptionsModal onClose={() => setShowOptions(false)} />}
    </div>
  );
};

export default Dashboard;